<!-- 新增收货地址页 -->
<template>
  <div class="loginAdd">
    <div class="wrapAdd">
      <div class="Hseat"></div>
      <div class="inputFormAdd">
        <div class="telDivAdd">
          <span>姓名：</span>
          <input class="pswWidth" type="text" placeholder="请输入姓名" v-model="consignee" />
        </div>

        <div class="telDivAdd">
          <span>联系电话：</span>
          <input class="pswWidth" type="text" placeholder="请输入电话" v-model="mobile"/>
        </div>

        <div class="telDivAdd">
          <span>所在地区：</span>
          <li style="width:70% ;text-align: left; font-size:14px" class="btn" ref="city" @click="pickerVisible = true">选择地区</li>
          <VuePicker
            :data="pickData"
            :layer="3"
            :showToolbar="true"
            @cancel="cancel"
            @confirm="confirm"
            :visible.sync="pickerVisible"
          />
        </div>

        <div class="telDivAdd">
          <span>详细地址：</span>
          <textarea rows="10" cols="30" v-model="address"></textarea>
        </div>
        <div class="Hseat"></div>
      </div>
      <div class="loginBtn" @click="save">保存地址</div>
    </div>
  </div>
</template>

<script>
import * as api from "@/api";
import { mapMutations } from "vuex";
import JmmToast from '@/components/JmmToast'
import VuePicker from "vue-pickers";
import cityData from "../../utils/CityData.js"
let realnameRegular = /^[\u0391-\uFFE5]+$/;
const deepFreeze = function(obj) {
    var propNames = Object.getOwnPropertyNames(obj);
    propNames.forEach(function(name) {
      var prop = obj[name];
      if (typeof prop == 'object' && prop !== null) {
        deepFreeze(prop);
      }
    })
    return Object.freeze(obj)
  }
  // 冻结以提升性能
  const freezeCityData = deepFreeze(cityData)
export default {
  name: "login",
  data() {
    return {
      token: "",
      sign: "",
      showToolbar: true,
      pickerVisible: false,
      pickData: freezeCityData,
      consignee:"",
      mobile:"",
      province:"",
      city:"",
      district:"",
      address:"",
    };
  },
  components: {
    VuePicker,
  },
  created() {
    this.merchantId = this.$route.query.merchantId;
    if(null != this.merchantId && undefined != this.merchantId && "merchantId" != this.merchantId){
      localStorage.setItem('cityMerchantId', this.merchantId);
    }
    this.token = this.$route.query.token;
    this.sign = this.$route.query.sign;
  },
  computed: {},
  mounted: function () {
  },
  methods: {
    // 点击保存
    async save() {
      let _this = this;
      if (_this.consignee == '') {
             JmmToast('姓名不能为空')
             return
      }
      if (_this.mobile == '') {
             JmmToast('联系电话不能为空')
             return
      }
      if (_this.province == '') {
             JmmToast('所在地区不能为空')
             return
      }
      if (_this.address == '') {
             JmmToast('详细地址不能为空')
             return
      }
      if (!realnameRegular.test(_this.consignee)) {
            JmmToast('姓名必须是汉字')
            return
          }
      try {
        let testToken = 'lmojakdhkadocfaccfjocklccdfkhgoj';
        let testSign = 'dpbijiiiefibmadgopamipinnnpnphof';
        localStorage.setItem('reToken', _this.token==undefined?testToken: _this.token);
        let info = {
          sign: _this.sign==undefined?testSign:_this.sign,
          consignee:_this.consignee,
          mobile:_this.mobile,
          province:_this.province,
          city:_this.city,
          district:_this.district,
          address:_this.address,
        }
        const { code, data, message } = await api.user.addressAdd(info);

        if (code == '000000') {
          _this.token = data.token;

          _this.changeLogin({ reToken: _this.token }); // 将用户token保存到vuex中
          _this.$router.push("/");
        } else {
          // HyrToast(submsg || msg)
        }
      } catch (err) {
        console.log(err);
      }
    },

    cancel() {
      console.log("cancel");
    },
    confirm(res) {
      let _this = this;
      let obj = JSON.parse(JSON.stringify(res));
      _this.province = obj[0].label
      _this.city = obj[1].label
      _this.district = obj[2].label
      let result = JSON.stringify(obj);
      this.$refs.city.textContent=_this.province+" " +_this.city+" "+_this.district

      // if (obj[0].children) {
      //   delete obj[0].children;
      // }
      // if (obj[1].children) {
      //   delete obj[1].children;
      // }
      // if (obj[2].children) {
      //   delete obj[2].children;
      // }
      // console.log(result);
      // console.log(a);
    },
  },
};
</script>

<style lang="stylus">
@import '../../assets/css/layout.styl';
@import '../../assets/css/common.styl';
@import '../../assets/css/icon.css';
@import '../../assets/css/stylesheet.css';

.wrapAdd {
  width: 100%;
  height: 100%;
}

.wrapAdd .headWrap {
  height: 88px;
  line-height: 88px;
  font-size: 36px;
  color: #262626;
  display: flex;
  width: calc(100% - 48px);
  margin: 0 auto;
}

.wrapAdd span {
  flex: 1;
}

.wrapAdd span:nth-child(1) img {
  width: 22px;
  height: 38px;
  vertical-align: middle;
}

.wrapAdd span:nth-child(2) {
  text-align: center;
}

.Hseat {
  height: 129px;
}

.telDivAdd {
  width: calc(100% - 150px);
  margin: 15px auto;
  height: 80px;
  border-bottom: 1px solid #ddd;
  display: flex;
}

.telDivAdd .coin {
  float: right;
  display: inline-block;
  font-size: 28px;
  align-self: center;
}

.telDivAdd i {
  right: 80px;
  position: absolute;
  margin-top: 0;
}

.telDivAdd textarea {
  border: 0;
  font-size: 28px;
  width: calc(100% - 120px);
}

.telDivAdd input {
  width: calc(100% - 120px);
  height: 66px;
  font-size: 28px;
}

.telDivAdd span {
  display: inline-block;
  float: left;
  align-self: center;
  width: 200px;
}

.loginBtn {
  width: calc(100% - 150px);
  height: 90px;
  line-height: 90px;
  background: $background;
  border-radius: 45px;
  font-size: 34px;
  text-align: center;
  color: $color;
  cursor: pointer;
  position: absolute;
  left: 0;
  right: 0;
  bottom: 40px;
  margin: auto;
}

.clearBoth {
  clear: both;
}

.leftRouter {
  float: $floLeft;
}

.rightRouter {
  float: $florRight;
}

.loginAdd {
  background: #fff;
}
</style>



// WEBPACK FOOTER //
// src/view/address/index.vue